import type { ModuleConfig } from "../moduleConfig.types";

export const reportsModuleConfig: ModuleConfig = {
  // ── Module-level base config ──────────────────────────────────────────────
  config: {
    type: "MODULE",
    supportMarkets: false,
    supportBrands: false,
    supportSecondaryBrands: false,
    supportMode: false,
    supportBase: false,
    supportDatePeriod: false,
    supportVisualisationSwitch: false,
    supportedURLKeys: [],
  },
};
